import React from 'react';
import classNames from 'classnames';
import Flex from '../../../../../components/common/Flex';
import PropTypes from 'prop-types';
import { Card, Col, ProgressBar, Row } from 'react-bootstrap';
import { useEstadiasStore } from '../../../../../lib/store/estadias.store';
import FalconCardHeader from '../../../../../components/common/FalconCardHeader';

const EstadiasTiempoUbi = ({ data, className }) => {
    console.log("[EstadiasTiempoUbi] Datos recibidos:", data);

    if (!Array.isArray(data) || data.length === 0) {
        return (
            <Card className={className}>
                <Card.Body>
                    <h6 className="mb-3 text-800">
                        Tiempo de estadía por ubicación
                    </h6>
                    <div className="text-center text-muted">
                        <p>No hay datos para mostrar</p>
                    </div>
                </Card.Body>
            </Card>
        );
    }

    const setFiltroEstadiaTiempo = useEstadiasStore((state) => state.setFiltroEstadiaTiempo)

    // ✅ MAPEO MÁS FLEXIBLE PARA CATEGORÍAS
    const groupMapping = {
        'Cliente': { title: 'Clientes', color: '#007bff' },
        'Clientes': { title: 'Clientes', color: '#007bff' },
        'cliente': { title: 'Clientes', color: '#007bff' },
        'clientes': { title: 'Clientes', color: '#007bff' },

        'Geocerca': { title: 'Geocercas', color: '#fd7e14' },
        'Geocercas': { title: 'Geocercas', color: '#fd7e14' },
        'geocerca': { title: 'Geocercas', color: '#fd7e14' },
        'geocercas': { title: 'Geocercas', color: '#fd7e14' },

        'Referencia': { title: 'Referencias', color: '#17a2b8' },
        'Referencias': { title: 'Referencias', color: '#17a2b8' },
        'referencia': { title: 'Referencias', color: '#17a2b8' },
        'referencias': { title: 'Referencias', color: '#17a2b8' },

        'Indeterminado': { title: 'Indeterminado', color: '#6c757d' },
        'indeterminado': { title: 'Indeterminado', color: '#6c757d' }
    };

    // ✅ NORMALIZAR CATEGORÍAS - Inicializar grupos principales
    const groupedData = {
        'clientes': { title: 'Clientes', color: '#007bff', segundos: 0 },
        'geocercas': { title: 'Geocercas', color: '#fd7e14', segundos: 0 },
        'referencias': { title: 'Referencias', color: '#17a2b8', segundos: 0 },
        'indeterminado': { title: 'Indeterminado', color: '#6c757d', segundos: 0 }
    };

    // ✅ PROCESAR DATOS CON MAPEO FLEXIBLE
    data.forEach(entry => {
        console.log("[EstadiasTiempoUbi] Procesando entry:", {
            category: entry.category,
            segundos: entry.segundos
        });

        // Buscar el mapeo correcto
        const mapping = groupMapping[entry.category];
        if (mapping) {
            const normalizedKey = mapping.title.toLowerCase();
            if (groupedData[normalizedKey]) {
                groupedData[normalizedKey].segundos += entry.segundos || 0;
            }
        } else {
            // Si no encuentra la categoría, agregar a indeterminado
            console.warn("[EstadiasTiempoUbi] Categoría no reconocida:", entry.category);
            groupedData['indeterminado'].segundos += entry.segundos || 0;
        }
    });

    const formattedData = Object.values(groupedData).filter(group => group.segundos > 0);
    const totalHours = formattedData.reduce((total, currentValue) => total + currentValue.segundos, 0);

    console.log("[EstadiasTiempoUbi] Datos procesados:", {
        formattedData,
        totalHours
    });

    // ✅ VALIDAR QUE HAY DATOS PARA MOSTRAR
    if (totalHours === 0) {
        return (
            <Card className={className}>
                <Card.Body>
                    <h6 className="mb-3 text-800">
                        Tiempo de estadía por ubicación
                    </h6>
                    <div className="text-center text-muted">
                        <p>No hay tiempo de estadía registrado</p>
                    </div>
                </Card.Body>
            </Card>
        );
    }

    const handleClickProgress = (data) => {
        setFiltroEstadiaTiempo(data.title)
    }

    return (
        <Card className={className}>

            <FalconCardHeader
                title={'Tiempo de estadía por ubicación'}
                light
                titleTag="h6"
            ></FalconCardHeader>

            <Card.Body >

                {/* <h6 className="mb-3 text-800">
                    Tiempo de estadía por ubicación
                </h6> */}
                <ProgressBar
                    style={{ height: 20 }}
                    className="shadow-none rounded-4 mt-4"
                >
                    {formattedData.map((group, index) => {
                        const percentage = (group.segundos * 100) / totalHours;
                        return (
                            <ProgressBar
                                style={{ backgroundColor: group.color, cursor: 'pointer' }}
                                now={percentage}
                                key={group.title}
                                className={classNames('overflow-visible position-relative', {
                                    'rounded-end rounded-pill': index === 0,
                                    'rounded-start rounded-pill': index === formattedData.length - 1,
                                    'border-end border-100 border-2': index !== formattedData.length - 1,
                                    'rounded-0': index !== formattedData.length - 1 && index !== 0
                                })}
                                onClick={() => handleClickProgress(group)}
                            />
                        );
                    })}
                </ProgressBar>

            </Card.Body>

            <Card.Footer>
                <Row className="fw-semibold text-small-estadias">
                    {formattedData.map(group => {
                        const percentage = ((group.segundos * 100) / totalHours);
                        return (
                            <Col
                                xs={6}
                                sm="auto"
                                as={Flex}
                                alignItems="center"
                                className="pe-2"
                                key={group.title}
                            >
                                <span
                                    className="dot"
                                    style={{ backgroundColor: group.color, width: 10, height: 10, borderRadius: '50%', display: 'inline-block', marginRight: 5 }}
                                ></span>
                                <span>{group.title}</span>
                                <span className="ms-1">
                                    {isNaN(percentage) ? '0' : percentage.toFixed(0)}%
                                </span>
                            </Col>
                        );
                    })}
                </Row>
            </Card.Footer>
        </Card>
    );
};

EstadiasTiempoUbi.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            category: PropTypes.string.isRequired,
            segundos: PropTypes.number.isRequired
        }).isRequired
    ),
    className: PropTypes.string
};

export default EstadiasTiempoUbi;


// import React from 'react';
// import classNames from 'classnames';
// import Flex from '../../../../../components/common/Flex';
// import PropTypes from 'prop-types';
// import { Card, Col, ProgressBar, Row } from 'react-bootstrap';
// import { useEstadiasStore } from '../../../../../lib/store/estadias.store';

// const EstadiasTiempoUbi = ({ data, className }) => {
//     if (!Array.isArray(data) || data.length === 0) {
//         return null; // Evita renderizar si no hay datos
//     }

//     const setFiltroEstadiaTiempo = useEstadiasStore((state) => state.setFiltroEstadiaTiempo)

//     // Definir los cuatro grupos principales
//     const groupMapping = {
//         'Cliente': { title: 'Clientes', color: '#007bff' },
//         'Geocerca': { title: 'Geocercas', color: '#fd7e14' },
//         'Referencia': { title: 'Referencias', color: '#17a2b8' },
//         'Indeterminado': { title: 'Indeterminado', color: '#6c757d' }
//     };

//     // Agrupar los datos según los grupos principales
//     const groupedData = Object.keys(groupMapping).reduce((acc, category) => {
//         acc[category.toLowerCase()] = { ...groupMapping[category], segundos: 0 };
//         return acc;
//     }, {});

//     data.forEach(entry => {
//         if (groupedData[entry.category]) {
//             groupedData[entry.category].segundos += entry.segundos;
//         }
//     });

//     const formattedData = Object.values(groupedData);
//     const totalHours = formattedData.reduce((total, currentValue) => total + currentValue.segundos, 0);

//     const handleClickProgress = (data) => {

//         setFiltroEstadiaTiempo(data.title)
//     }

//     return (
//         <Card className={className}>
//             <Card.Body>
//                 <h6 className="mb-3 text-800">
//                     Tiempo de estadía por ubicación
//                 </h6>
//                 <ProgressBar
//                     style={{ height: 10 }}
//                     className="shadow-none rounded-4 mb-3"
//                 >
//                     {formattedData.map((group, index) => (
//                         <ProgressBar
//                             style={{ backgroundColor: group.color, cursor: 'pointer' }}
//                             now={(group.segundos * 100) / totalHours}
//                             key={group.title}
//                             className={classNames('overflow-visible position-relative', {
//                                 'rounded-end rounded-pill': index === 0,
//                                 'rounded-start rounded-pill': index === formattedData.length - 1,
//                                 'border-end border-100 border-2': index !== formattedData.length - 1,
//                                 'rounded-0': index !== formattedData.length - 1 && index !== 0
//                             })}
//                             onClick={() => handleClickProgress(group)}
//                         />
//                     ))}
//                 </ProgressBar>
//                 <Row className="fs-10 fw-semibold text-500">
//                     {formattedData.map(group => (
//                         <Col
//                             xs={6}
//                             sm="auto"
//                             as={Flex}
//                             alignItems="center"
//                             className="pe-2"
//                             key={group.title}
//                         >
//                             <span
//                                 className="dot"
//                                 style={{ backgroundColor: group.color, width: 10, height: 10, borderRadius: '50%', display: 'inline-block', marginRight: 5 }}
//                             ></span>
//                             <span>{group.title}</span>
//                             <span className="ms-1">{((group.segundos * 100) / totalHours).toFixed(0)}%</span>
//                         </Col>
//                     ))}
//                 </Row>
//             </Card.Body>
//         </Card>
//     );
// };

// EstadiasTiempoUbi.propTypes = {
//     data: PropTypes.arrayOf(
//         PropTypes.shape({
//             category: PropTypes.string.isRequired, // Categoría principal: Clientes, Geocercas, Referencias, Indeterminado
//             segundos: PropTypes.number.isRequired
//         }).isRequired
//     ),
//     className: PropTypes.string
// };

// export default EstadiasTiempoUbi;
